import styled from "styled-components";
import { Parallax, Background } from "react-parallax";
import Responsive from "./media-queries";
import { H1 } from "./text";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const ParallaxWrapper = styled(Parallax)`
  background: ${(props) =>
    props.colour === "primary"
      ? props.theme.colours.primary
      : props.colour === "secondary"
      ? props.theme.colours.secondary
      : props.theme.colours.white};
  min-height: ${(props) => (props.height ? props.height : "300px")};
  padding: ${(props) => (props.fullscreen ? "0" : "110px 0 0 0")};

  .react-parallax-background-children {
    height: 100%;
    opacity: 0.2;
    width: 100%;

    .react-parallax-background {
      height: 100%;

      .gatsby-image-wrapper {
        height: 100%;
      }
    }
  }

  ${Responsive.lg} {
    padding: ${(props) => (props.fullscreen ? "0" : "70px 0 0 0")};
  }
`;

const HeroContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: ${(props) => (props.height ? props.height : "300px")};
  justify-content: center;
  overflow: hidden;
  position: relative;
  padding: 25px;

  ${Responsive.lg} {
    padding: 50px;
    min-height: ${(props) => (props.height ? props.height : "500px")};

    ${({ fullscreen }) => fullscreen && `min-height: 100vh;`}
  }

  ${({ fullscreen }) => fullscreen && `min-height: 100vh;`}
`;

const HeroContent = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colours.white};
  display: flex;
  height: ${(props) => (props.height ? props.height : "300px")};
  justify-content: center;
  max-width: ${(props) => props.theme.layout.maxWidth};
  padding: 0 ${(props) => props.theme.layout.gutter.md};
  text-align: center;

  h1 {
    margin: 0;
    text-shadow: 0px 0px 30px ${(props) => props.theme.colours.darkGrey};
  }

  ${Responsive.lg} {
    height: ${(props) => (props.height ? props.height : "500px")};
    padding: 0;
  }
`;

export const Hero = (props) => {
  const image = getImage(props.image);
  return (
    <ParallaxWrapper
      className={props.className}
      colour={props.colour}
      fullscreen={props.fullscreen}
      height={props.height}
      strength={500}
    >
      <HeroContainer fullscreen={props.fullscreen} height={props.height}>
        {props.title ? (
          <HeroContent className="hero-content" height={props.height}>
            <H1>{props.title}</H1>
          </HeroContent>
        ) : (
          props.children
        )}
      </HeroContainer>
      {props.image && (
        <Background className="custom-bg">
          <GatsbyImage alt={props.title ?? ""} image={image} />
        </Background>
      )}
    </ParallaxWrapper>
  );
};
